<template lang="pug">
table.table.table-striped.table-hover.table-sm
  thead
    tr
      th {{ "pontuacao_resumo.matricula" | tModel }}
      th {{ "pontuacao_resumo.usuario.nome" | tModel }}
      th(v-if="!internos") Pontos
      th(v-if="internos") Média % da GPD
      th(v-else) % da GPD
      th(v-if="internos") Valor Média %
      th(v-else) Valor da Pontuação
      th Dias Afastamento
      th Valor Afastamento
      th Valor Total
      th
  tbody
    router-link.c-hand(
      tag="tr",
      v-for="row in resumos",
      :key="row.id",
      :to="{ name: 'app.produtividade.geral.resumos.show', params: { geralId: row.pontuacao_geral_id, resumoId: row.id } }"
    )
      td {{ row.usuario.matricula || "-" }}
      td {{ row.usuario.nome }}
      td.text-center(v-if="!internos") {{ row.total | currency }}
      td.text-center {{ row.percentual_total | currency }}
      td.text-center {{ row.valor_total_atingido | currency }}
      td.text-center {{ row.dias_afastado || "-" }}
      td.text-center {{ row.media_individual_recebimento | currency }}
      td.text-center {{ row.valor_total | currency }}
      td
        i.fa.fa-chevron-right
</template>

<script>
export default {
  props: {
    resumos: { type: Array, required: true },
    internos: { type: Boolean, default: false },
  },
}
</script>
